import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const adobedtmUrl = window['env'][window['env']['envName']].adobedtmUrl;

addScript();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

function addScript() {
  const script = document.createElement('script');
  script.src = adobedtmUrl;
  document.head.appendChild(script);
}

